// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Of","itemsContainer":"Pf"};